// extracted by mini-css-extract-plugin
export default {"announcer":"E6GUnIS AQi6YMD"};